export default __webpack_public_path__ + "static/media/EarthFever_00.aec0019a.png";